import { createContext, useContext, useEffect, useState } from "react";
import es from "@/locales/es";
import en from "@/locales/en";
import pt from "@/locales/pt";
import fr from "@/locales/fr";
import it from "@/locales/it";

export const LANGS = ["es", "en", "pt", "fr", "it"];

const DICT = { es, en, pt, fr, it };
const LangCtx = createContext({ lang: "es", t: es, setLang: () => {} });

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("gcc-lang");
    return LANGS.includes(saved) ? saved : "es";
  });
  useEffect(() => {
    localStorage.setItem("gcc-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  return <LangCtx.Provider value={{ lang, setLang, t: DICT[lang] }}>{children}</LangCtx.Provider>;
};

export const useLang = () => useContext(LangCtx);
